import ChatPanelRuntime from 'components/Chat/ChatPanelRuntime';
import useStudentSubmissionChat from 'hooks/chat/useStudentSubmissionChat';
import { shouldShowChatSuggestions } from 'utils/chat';

const StudentSubmissionChatPanel = ({ currentSubmission, isOpen, onBack, onChatUpdated, resolveChat }) => {
    const {
        chat,
        fileKey,
        hasOlderMessages,
        isBootstrapping,
        isLoadingOlderMessages,
        loadOlderMessages,
        onChatRequestStateChange,
        showSuggestions,
        suggestions,
        viewModel,
    } = useStudentSubmissionChat({
        currentSubmission,
        isOpen,
        onChatUpdated,
        resolveChat,
        shouldShowChatSuggestions,
    });

    const chatPanelProps = {
        chat,
        fileKey,
        hasOlderMessages,
        isBootstrapping,
        isLoadingOlderMessages,
        isOpen,
        onBack,
        onChatRequestStateChange,
        onLoadOlderMessages: loadOlderMessages,
        showSuggestions,
        suggestions,
        viewModel,
    };

    return <ChatPanelRuntime {...chatPanelProps} />;
};

export default StudentSubmissionChatPanel;
